export { default } from './container';


// WEBPACK FOOTER //
// ./components/Agile/projectPriority/index.js